import { NewsletterModel } from '@modules/newsletter/newsletter-model';

const { fields } = NewsletterModel;

export default [
  fields.name,
  fields.lastname,
  fields.email,
  fields.zipcode,
  fields.state,
];
